import MaintenanceConfig from './MaintenanceConfig';
export default MaintenanceConfig;
